<template>
  <main>
    <RouterView />
  </main>
</template>

<style lang="scss" scoped>
.container-main {
  padding: 0;
}
</style>
